/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function HeaderMenu({ layoutProps }) {
    const location = useLocation();
    const getMenuItemActive = (url) => {
        return checkIsActive(location, url) ? "menu-item-active" : "";
    }

    return <div
        id="kt_header_menu"
        className={`header-menu header-menu-left header-menu-mobile ${layoutProps.ktMenuClasses}`}
        {...layoutProps.headerMenuAttributes}
    >
        {/*begin::Header Nav*/}
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
            {/*begin::1 Level*/}

            {/*end::1 Level*/}

            {/*Classic submenu*/}
            <li
                data-menu-toggle={layoutProps.menuDesktopToggle}
                aria-haspopup="true"
                className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/master')}`}>
                <NavLink className="menu-link menu-toggle" to="/master">
                    <span className="menu-text">Setup</span>
                    <i className="menu-arrow"></i>
                </NavLink>
                <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                    <ul className="menu-subnav">
                        {/*begin::3 Level*/}
                        {/* <li className={`menu-item ${getMenuItemActive('/master/customers')}`}>
                            <NavLink className="menu-link" to="/master/customers">
                                <span className="menu-text">Vendors</span>
                            </NavLink>
                        </li> */}
                        <li className={`menu-item ${getMenuItemActive('/master/vehicles')}`}>
                            <NavLink className="menu-link" to="/master/vehicles">
                                <span className="menu-text">Vehicles</span>
                            </NavLink>
                        </li>
                        {/* <li className={`menu-item ${getMenuItemActive('/master/pits')}`}>
                            <NavLink className="menu-link" to="/master/pits">
                                <span className="menu-text">Pit</span>
                            </NavLink>
                        </li> */}
                        <li className={`menu-item ${getMenuItemActive('/master/quality')}`}>
                            <NavLink className="menu-link" to="/master/quality">
                                <span className="menu-text">Quality</span>
                            </NavLink>
                        </li>
                        {/*end::3 Level*/}

                    </ul>
                </div>
            </li>
            {/*begin::1 Level*/}
            <li
                data-menu-toggle={layoutProps.menuDesktopToggle}
                aria-haspopup="true"
                className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/custom')}`}>
                <NavLink className="menu-link menu-toggle" to="/custom">
                    <span className="menu-text">Trip Tracking</span>
                    <i className="menu-arrow"></i>
                </NavLink>
                <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                    <ul className="menu-subnav">
{/* 
                        <li className={`menu-item ${getMenuItemActive('/trip-tracking/dashboard')}`}>
                            <NavLink className="menu-link" to="/trip-tracking/dashboard">
                                <span className="menu-text">Dashboard</span>
                            </NavLink>
                        </li> */}

                        {/*begin::2 Level*/}
                        <li className={`menu-item ${getMenuItemActive('/trip-tracking/trips')}`}>
                            <NavLink className="menu-link" to="/trip-tracking/trips">
                                <span className="menu-text">Trips</span>
                            </NavLink>
                        </li>
                        {/*end::3 Level*/}

                        {/*begin::2 Level*/}
                        <li className={`menu-item ${getMenuItemActive('/trip-tracking/devicelocations')}`}>
                            <NavLink className="menu-link" to="/trip-tracking/devicelocations">
                                <span className="menu-text">Live Location</span>
                            </NavLink>
                        </li>
                        {/*end::3 Level*/}

                    </ul>
                </div>
            </li>

                        <li
                data-menu-toggle={layoutProps.menuDesktopToggle}
                aria-haspopup="true"
                className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/reports')}`}>
                <NavLink className="menu-link menu-toggle" to="/reports">
                    <span className="menu-text">Reports</span>
                    <i className="menu-arrow"></i>
                </NavLink>
                <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                    <ul className="menu-subnav">
                        {/*begin::2 Level*/}
                        <li
                            className={`menu-item menu-item-submenu ${getMenuItemActive('/reports/transporter')}`}
                            data-menu-toggle="hover"
                            aria-haspopup="true"
                        >
                            <NavLink className="menu-link menu-toggle" to="/reports/transporter">
                                <span className="svg-icon menu-icon">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Design/PenAndRuller.svg")} />
                                </span>
                                <span className="menu-text">
                                    Transporter
                                </span>
                                <i className="menu-arrow" />
                            </NavLink>
                            <div className={`menu-submenu menu-submenu-classic menu-submenu-right`}>
                                <ul className="menu-subnav">
                                    <li className={`menu-item ${getMenuItemActive('/reports/transporter/volumebyday')}`}>
                                        <NavLink className="menu-link" to="/reports/transporter/volumebyday">
                                            <span className="menu-text">Daily Volume</span>
                                        </NavLink>
                                    </li>
                                    <li className={`menu-item ${getMenuItemActive('/reports/transporter/tripsbyday')}`}>
                                        <NavLink className="menu-link" to="/reports/transporter/tripsbyday">
                                            <span className="menu-text">Daily Trip Count</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        {/*end::3 Level*/}

                        {/*begin::2 Level*/}


                        {/*end::3 Level*/}
                    </ul>
                </div>
            </li>

            <li
                data-menu-toggle={layoutProps.menuDesktopToggle}
                aria-haspopup="true"
                className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/metrics')}`}>
                <NavLink className="menu-link menu-toggle" to="/metrics">
                    <span className="menu-text">Monitoring</span>
                    <i className="menu-arrow"></i>
                </NavLink>
                <div className="menu-submenu menu-submenu-classic menu-submenu-left">
                    <ul className="menu-subnav">
                        {/*begin::3 Level*/}
                        
                        <li className={`menu-item ${getMenuItemActive('/metrics/metrics')}`}>
                            <NavLink className="menu-link" to="/metrics/metrics">
                                <span className="menu-text">Applications Health</span>
                            </NavLink>
                        </li>
                        <li className={`menu-item ${getMenuItemActive('/metrics/delayedtrips')}`}>
                            <NavLink className="menu-link" to="/metrics/delayedtrips">
                                <span className="menu-text">Monitor Trip Time</span>
                            </NavLink>
                        </li>
                        {/*end::3 Level*/}

                    </ul>
                </div>
            </li>

        </ul>
        {/*end::Header Nav*/}
    </div>;
}
